﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";
import queryString from "query-string";
import {loaderShow, loaderHide} from "./loader";
import {applyVatPrices} from "./vat-toggle";

const formSelector = '[data-form="product-search"]';
const orderSelector = '[data-form="product-search-order"]';
const paginationSelector = '[data-form="product-search-pagination"]';
const resultsSelector = '[data-content="product-search"]';

export function initSearchForm() {
    if ($(orderSelector).length) {
        $(orderSelector).on('change', function () {
            let order = $(this).val();
            $(formSelector).find('input[name=OrderType]').val(order);
            $($(formSelector)[0]).trigger('submit');
        });
    }

    if ($(formSelector).length) {
        $(formSelector).on('submit', function (e) {
            e.preventDefault();
            let form = $(this);
            form.find('[name=PageNumber]').val(1);
            let url = form.attr('action');
            let data = form.serialize();
            getSearchData(url, data, pushState);
        });

        $(formSelector).find('input:not([data-ignore]),select:not([data-ignore])').on('change', function (e) {
            let form = $(this).closest(formSelector);
            form.trigger('submit');
        });

        $(formSelector).find('input').on('keypress', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                $($(formSelector)[0]).trigger('submit');
            }
        });
    }

    initPagination();

    window.addEventListener('popstate', (event) => {
        applyFilterFromUrl(document.location);
    });

    $('select[data-page-load]').on("change", function () {
        let self = $(this);
        if (self.val().length) {
            window.location = self.val();
        }
    });
}

function initPagination() {
    if ($(paginationSelector).length) {
        $(paginationSelector).find('a.page-link').on('click', function (e) {
            e.preventDefault();
            let link = $(this);
            let url = link.attr('href');

            let data = queryString.parse(url.split('?')[1]);

            let form = $($(formSelector)[0]);
            let formData = form.serialize();
            let formDataObject = queryString.parse(formData);

            formDataObject.PageNumber = data.PageNumber;

            getSearchData(url, queryString.stringify(formDataObject), pushState);

        });
    }
}

function pushState(data) {
    let parsed = queryString.parse(data);
    let {__RequestVerificationToken, ...newData} = parsed
    let url = window.location.pathname + '?' + queryString.stringify(newData);

    window.history.pushState({}, null, url);
}

function applyFilterFromUrl() {
    let form = $(formSelector);
    let parsed = queryString.parse(location.search);
    for (const [key, value] of Object.entries(parsed)) {
        let element = form.find('[name=' + key + ']');
        if (element.length) {
            element.val(value);
        }

        if (key === 'OrderType') {
            $(orderSelector).val(value);
        }
    }

    if (!parsed.PageNumber) {
        form.find('[name=PageNumber]').val(1);
    }

    let url = $(form[0]).attr('action');
    let data = $(form[0]).serialize();

    getSearchData(url, data);
}

function getSearchData(url, data, preSearchCallBack = function (data) {
}) {
    loaderShow(resultsSelector);
    preSearchCallBack(data);
    ajax({
        url: url,
        data: data,
        method: 'POST',
        success: function (response) {
            $(resultsSelector).html(response);
            $('[data-form="product-search-info"]').html($(resultsSelector).find('[data-form="product-search-info"]').html());
            $(resultsSelector).find('[data-form="product-search-info"]').remove();
            initPagination();
            applyVatPrices(resultsSelector);
        }
        , error: function (error) {
            console.error(error);
        }
        , complete: function () {
            loaderHide(resultsSelector);
        }
    });
}